export default __webpack_public_path__ + "static/favicon-4cc10833650cf0fa7228338ee6e8c819.png";